var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectionalRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7835 17.0259C18.7846 16.4595 18.5767 15.9105 18.1958 15.4744L5.42045 0.928406C4.98676 0.433318 4.36354 0.121975 3.68792 0.0628707C3.01229 0.00376629 2.33959 0.201742 1.8178 0.613244C1.29601 1.02475 0.967879 1.61607 0.905587 2.25712C0.843295 2.89818 1.05195 3.53646 1.48564 4.03155L12.9324 17.0259L1.89445 30.0203C1.68222 30.2683 1.52372 30.5537 1.42808 30.8599C1.33244 31.1662 1.30154 31.4874 1.33715 31.8051C1.37277 32.1227 1.4742 32.4306 1.63561 32.7109C1.79702 32.9913 2.01524 33.2386 2.27771 33.4387C2.54043 33.6607 2.84864 33.8288 3.18303 33.9326C3.51742 34.0363 3.87079 34.0734 4.221 34.0415C4.5712 34.0097 4.9107 33.9095 5.21822 33.7474C5.52574 33.5852 5.79465 33.3646 6.00812 33.0992L18.3491 18.5533C18.6698 18.1046 18.8227 17.5668 18.7835 17.0259Z",
    fill: "current-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionalRight);
export default __webpack_public_path__ + "static/media/directional-right.6c7dc294.svg";
export { ForwardRef as ReactComponent };